import "./Disclaimer.module.css";
import Header from "@/reusable_sections/Header";
import BookContent from "./sections/BookContent";
import Footer from "@/reusable_sections/Footer";
export default function DisclaimerPage() {
  return <div>
      <Header />
      <BookContent />
      <Footer />
    </div>;
}